import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  ViewChild,
  TemplateRef
} from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { CpmService } from '../../service/cpm.service'
import { StoreService } from '../../service/store.service'
import { CompanyAeTableComponent } from '../company-ae-table/company-ae-table.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap'

@Component({
  selector: 'app-company-ae',
  templateUrl: './company-ae.component.html',
  styleUrls: ['./company-ae.component.scss']
})
export class CompanyAeComponent implements OnInit, OnDestroy {

  @ViewChild(CompanyAeTableComponent) companyAeTableComponent: CompanyAeTableComponent
  @ViewChild('templateSaved') templateSaved: TemplateRef<any>
  @Input() printPage

  modalRef: BsModalRef
  createFormData
  editId
  message

  modalConfig: {
    animated: true
    keyboard: true
    backdrop: true
    ignoreBackdropClick: true
  }

  displayAddPage = false;
  displayEditPage = false;
  displayDeletePage = false;

  constructor(
    private store: StoreService,
    private cpmService: CpmService,
    private activatedRoute: ActivatedRoute,
    private modalService: BsModalService
  ) { }

  ngOnInit() {
  }

  createCaseHandler(event) {
    this.displayAddPage = true
    this.displayEditPage = false
    this.displayDeletePage = false
    this.createFormData = event
  }

  editCaseHandler(event) {
    this.displayAddPage = false
    this.displayEditPage = true
    this.displayDeletePage = false
    this.editId = event
  }

  DeleteCaseHandler(event) {
    this.displayAddPage = false
    this.displayEditPage = false
    this.displayDeletePage = false
    this.editId = event
  }

  onFinished(event) {
    this.displayAddPage = false
    this.displayEditPage = false
    this.displayDeletePage = false
    // this.alert(event)

    // this.companyAeTableComponent.listAe = []
    this.companyAeTableComponent.getCompanyAEdata()

  }

  alert(event) {
    switch (event.status) {
      case 'OK':
        this.message = 'Successful'
        break
      case 'WARNNING':
        this.message = event.message
        break
      default:
        this.message = event.message
    }
    this.openModal(this.templateSaved)
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, this.modalConfig, { class: 'modal-sm' })
    )
  }

  closeModal() {
    this.modalRef.hide()
  }

  exportFunctions() {
    const arrayOfFunctions: Map<String, Function> = new Map<String, Function>()
    arrayOfFunctions.set('excel', this.exportExcelCompanyAE())
    return arrayOfFunctions
  }

  exportExcelCompanyAE() {
    return function excelCompanyAE() {

    }
  }


  ngOnDestroy(): void { }

}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/admin/company-ae/company-ae.component.ts